import { Button, Input, Popconfirm, Select, message } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'
import API from '../../../utils/api'
import { useToken } from '../../hooks'

const SettingSaveInput = ({ data, mutate }: any) => {
	const [type, setType] = React.useState(data?.type)
	const [value, setValue] = React.useState(data?.value)
	const { data: token } = useToken()
	const saveKey = () => {
		API.post('/admin/user/setting', token + '', {
			userid: data?.user_id,
			type,
			key: data?.key,
			value,
		}).then(res => {
			if (res.result.success) {
				message.success('성공')
				mutate();
			} else {
				message.error(res?.result?.message || '실패')
			}
		})
	}
	const delKey = () => {
		API.delete('/admin/user/setting', token + '', {
			userid: data?.user_id,
			type,
			key: data?.key,
			value,
		}).then(res => {
			if (res.result.success) {
				message.success('성공')
				mutate();
			} else {
				message.error(res?.result?.message || '실패')
			}
		})
	}

	return (
		<View style={{ width: '100%', flexDirection: 'row' }}>
			<Select
				options={[
					{ label: '거래', value: 1 },
					{ label: '일반', value: 2 },
				]}
				value={type}
				onChange={e => setType(e + '')}
				size="small"
			/>
			<Input
				defaultValue={data?.value}
				value={value}
				onChange={e => {
					setValue(e.target.value)
				}}
				size="small"
			/>
			<Popconfirm title="저장하시겠습니까?" onConfirm={saveKey}>
				<Button size="small" type="primary" style={{ marginLeft: 5 }}>
					저장
				</Button>
			</Popconfirm>
			<Popconfirm title="삭제하시겠습니까?" onConfirm={delKey}>
				<Button size="small" type="primary" style={{ marginLeft: 5 }}>
					삭제
				</Button>
			</Popconfirm>
		</View>
	)
}

export default React.memo(SettingSaveInput)
